// for validating eemail
export const RegexEmail = /^(?!\.)(?!.*\.$)(?!.*?\.\.)(?!.*?\.@)([a-zA-Z0-9_\.]+)@((\[[0-9]{1,3}[0-9]{1,3}[0-9]{1,3}\.)|(([a-zA-Z0-9]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;

// for validating names and white space
export const Alpha = /^[a-zA-Zñáéíóúü][a-zA-Zñáéíóúü\s]*$/;

// for validating if value is not white space
export const RegexForAcceptAllExceptWhitespace = /^[^\s].*/;
